import { NO_FLAVORS_KEY } from "Root/profile/components/common/SubscriptionFlavorsSelect";
import { uuid } from "Root/profile/utils";
import { SET_USER_CART, SET_FLAVOR_AMOUNT, SET_ATTRIBUTE, SET_QUANTITY, SET_BAGS_INFO } from "../actions/types";
export default function userCartReducer(state = [], action) {
    switch (action.type) {
        case SET_USER_CART: {
            const payload = action.payload;
            return payload.map((user) => ({ ...user, currentReduxQuantity: user.quantity }));
        }
        case SET_FLAVOR_AMOUNT: {
            const flavorPayload = action.payload;
            return [
                ...state.map((item) => ({
                    ...item,
                    bags_info: item.bags_info.map((bag) => {
                        if (bag.id === flavorPayload.bagId) {
                            return {
                                ...bag,
                                selected_flavors: bag.selected_flavors.length
                                    ? bag.selected_flavors.map((flavor) => {
                                        if (flavor.short_name === flavorPayload.name) {
                                            return {
                                                ...flavor,
                                                count: flavorPayload.value,
                                            };
                                        }
                                        if (flavorPayload.name === NO_FLAVORS_KEY) {
                                            return {
                                                ...flavor,
                                                count: 0,
                                            };
                                        }
                                        return flavor;
                                    })
                                    : [{ short_name: flavorPayload.name, count: flavorPayload.value }],
                            };
                        }
                        return bag;
                    }),
                })),
            ];
        }
        case SET_ATTRIBUTE: {
            const attributePayload = action.payload;
            return [
                ...state.map((item) => ({
                    ...item,
                    bags_info: item.bags_info.map((bag) => {
                        if (bag.id === attributePayload.bagId) {
                            return {
                                ...bag,
                                attributes: bag.attributes.map((attribute) => {
                                    if (attribute.attribute_name === attributePayload.name) {
                                        return {
                                            ...attribute,
                                            attribute_on: attributePayload.value,
                                        };
                                    }
                                    return attribute;
                                }),
                            };
                        }
                        return bag;
                    }),
                })),
            ];
        }
        case SET_QUANTITY: {
            const getDefaultBagInfo = (itemType) => {
                const cartItem = state.find((item) => item.item_type === itemType);
                const attributes = JSON.parse(JSON.stringify(cartItem.attributes));
                return {
                    id: uuid(),
                    applyAll: false,
                    quantity: 1,
                    sku: "",
                    attributes,
                    selected_flavors: cartItem?.available_flavors.map((flavor) => ({
                        short_name: flavor.short_name,
                        count: 0,
                    })) || [],
                };
            };
            const newState = JSON.parse(JSON.stringify([...state]));
            const quantityPayload = action.payload;
            const updatedItem = newState.find((item) => item.sku === quantityPayload.name);
            if (updatedItem &&
                updatedItem.quantity !== undefined &&
                updatedItem.item_type !== "protein" &&
                updatedItem.available_flavors.length > 0) {
                if (Number(quantityPayload.value) === 0) {
                    updatedItem.bags_info = [];
                }
                else if (Number(quantityPayload.value) !== 0 && quantityPayload.value > updatedItem.quantity) {
                    const difference = Number(quantityPayload.value) - Number(updatedItem.quantity);
                    for (let i = 0; i < difference; i++) {
                        updatedItem.bags_info.push(getDefaultBagInfo(updatedItem.item_type));
                    }
                }
                else if (Number(quantityPayload.value) !== 0 && quantityPayload.value < updatedItem.quantity) {
                    const difference = Number(updatedItem.quantity) - Number(quantityPayload.value);
                    for (let i = 0; i < difference; i++) {
                        updatedItem.bags_info.pop();
                    }
                }
            }
            if (updatedItem?.quantity !== undefined) {
                updatedItem.quantity = Number(quantityPayload.value);
            }
            return [...newState];
        }
        case SET_BAGS_INFO: {
            const setBagInfoPayload = action.payload;
            return [
                ...state.map((item) => {
                    if (item.sku === setBagInfoPayload.name) {
                        if (setBagInfoPayload.applyAllValue) {
                            return {
                                ...item,
                                bags_info: item.bags_info.map((bag) => {
                                    const defaultBag = item.bags_info.find((bagInfo) => bagInfo.id === setBagInfoPayload.bagId);
                                    if (bag.id === setBagInfoPayload.bagId) {
                                        return {
                                            ...defaultBag,
                                            id: uuid(),
                                            applyAll: setBagInfoPayload.applyAllValue,
                                        };
                                    }
                                    return {
                                        ...defaultBag,
                                        id: uuid(),
                                        applyAll: false,
                                    };
                                }),
                            };
                        }
                        return {
                            ...item,
                            bags_info: item.bags_info.map((bag) => {
                                if (bag.id === setBagInfoPayload.bagId) {
                                    return {
                                        ...bag,
                                        applyAll: setBagInfoPayload.applyAllValue,
                                    };
                                }
                                return bag;
                            }),
                        };
                    }
                    return item;
                }),
            ];
        }
        default: {
            return state;
        }
    }
}
